import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import classes from "./inventorySparesLotListPage.module.css";

import { InventorySparesLotListFilterPage } from "./inventorySparesLotListFilterPage/InventorySparesLotListFilterPage";
import { InventorySparesLotListTablePage } from "./inventorySparesLotListTable/InventorySparesLotListTablePage";

import {
  useGetInventorySpareLotListQuery,
  makeInventorySpareLotSelectors,
  makeSelectInventorySpareLotPagination,
} from "../../../services/inventory/spares/inventorySpareLotListApiSlice";

import {
  selectInventorySpareLotFilterState,
  setInventorySpareLotListCursor,
} from "../../../store/inventory/inventorySpareLotListSlice";

export const InventorySparesLotListPage = () => {
  const navigate = useNavigate();
  const { inventoryId } = useParams();
  const dispatch = useDispatch();

  const filter = useSelector(selectInventorySpareLotFilterState);

  /* =====================
     BUILD FILTERS (IMPORTANT)
  ===================== */
  const filters = useMemo(() => {
    const result = {};
    if (filter.status !== null && filter.status !== "") {
      result.status = filter.status;
    }
    if (filter.search !== null && filter.search !== "") {
      result.search = filter.search;
    }
    return result;
  }, [filter.status, filter.search]);

  /* =====================
     API CALL (FIXED)
  ===================== */
  const { isLoading, isError } = useGetInventorySpareLotListQuery(
    {
      inventory_id: inventoryId,
      cursor: filter.cursor,
      filters, // ✅ CORRECT
    },
    {
      skip: !inventoryId,
      refetchOnMountOrArgChange: true,
    },
  );

  /* =====================
     SELECTORS (FACTORY)
  ===================== */
  const lotSelectors = useMemo(
    () => makeInventorySpareLotSelectors(inventoryId),
    [inventoryId],
  );

  const pagination = useSelector(
    makeSelectInventorySpareLotPagination(inventoryId),
  );

  const tableData = useSelector(lotSelectors.selectAll);

  /* =====================
     INFINITE SCROLL
  ===================== */
  const loadMore = useCallback(() => {
    if (!pagination.hasMore || pagination.nextCursor == null) return;
    dispatch(setInventorySpareLotListCursor(pagination.nextCursor));
  }, [dispatch, pagination]);

  /* =====================
     DERIVED DATA
  ===================== */
  const firstImageExist =
    tableData.length > 0 ? tableData[0].image_exist : null;

  /* =====================
     RENDER
  ===================== */
  if (isLoading && tableData.length === 0) {
    return <div>Loading...</div>;
  }

  if (isError && tableData.length === 0) {
    return <div>Error loading lots</div>;
  }

  return (
    <div className={classes.box}>
      <InventorySparesLotListFilterPage
        inventoryId={inventoryId}
        firstImageExist={firstImageExist}
        filters={filters}
      />

      <InventorySparesLotListTablePage
        data={tableData}
        hasMore={pagination.hasMore}
        onLoadMore={loadMore}
        isLoading={isLoading}
        isFetchingMore={isLoading}
        inventoryId={inventoryId}
      />
    </div>
  );
};
